import React from 'react';
import { ChartAxes } from './ChartAxes';
import { placeboTrajectory, results } from '../../data/study';
import { useChartGeometry } from '../../hooks/useChartGeometry';
import { estimateTrajectory, WEEKS } from '../../utils/chart';
import { palette } from '../../utils/palette';
type PredictionChartProps = {
  estimate: number;
  touched: boolean;
};
export function PredictionChart({
  estimate,
  touched
}: PredictionChartProps) {
  const geo = useChartGeometry();
  const {
    box,
    x,
    y,
    compact
  } = geo;
  const estimatePoints = estimateTrajectory(placeboTrajectory, estimate);
  const endX = x(WEEKS);
  const yP = y(results.placebo);
  const yE = y(results.placebo + estimate);
  const labelX = endX + (compact ? 18 : 26);
  const labelsClash = Math.abs(yP - yE) < 30;
  const fs = compact ? 10 : 12;
  const lineColor = touched ? palette.accent : palette.faint;
  return <svg viewBox={`0 0 ${box.width} ${box.height}`} className="h-auto w-full overflow-visible" aria-hidden="true" data-id="element-14" data-mp="2ohxk1h7lx391">
      <ChartAxes geo={geo} showValues={false} data-id="element-15" data-mp="35cdyo89fwqm" />
      {touched && <path d={geo.area(estimatePoints, placeboTrajectory)} fill={palette.accentSoft} data-id="element-16" data-mp="37ymor6w0iaf" />}
      <path d={geo.smooth(placeboTrajectory)} fill="none" stroke={palette.placebo} strokeWidth={2.5} strokeLinecap="round" data-id="element-17" data-mp="869wj1x6mssn" />
      <path d={geo.smooth(estimatePoints)} fill="none" stroke={lineColor} strokeWidth={touched ? 3.5 : 2} strokeDasharray={touched ? undefined : '4 5'} strokeLinecap="round" data-id="element-18" data-mp="3uc6snovw0zq6" />
      <circle cx={x(0)} cy={y(0)} r={4} fill={palette.ink} data-id="element-19" data-mp="qvpyltoimtb6" />
      <circle cx={endX} cy={yP} r={4.5} fill={palette.placebo} data-id="element-20" data-mp="qxar7dr9s26e" />
      <circle cx={endX} cy={yE} r={7} fill={palette.paper} stroke={lineColor} strokeWidth={2.5} data-id="element-21" data-mp="d3jsl0f2u2pg" />

      <text x={labelX} y={labelsClash ? yP + 18 : yP} dy="0.32em" fill={palette.muted} fontSize={fs} letterSpacing="0.06em" data-id="element-22" data-mp="h43oy1rtt2aj">
        PLACEBO
      </text>
      <text x={labelX} y={labelsClash ? yE - 14 : yE} dy="0.32em" fill={touched ? palette.accent : palette.muted} fontSize={fs} letterSpacing="0.06em" fontWeight={600} data-id="element-23" data-mp="19lpkk7p27sad">
        JASCAYD 18 mg
      </text>
    </svg>;
}